/**
 * @class
 * @description This class connect to cdn the cdb balancer api and hepls to get data
 * @exports TestProfilesBusinessObject
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import PingTimeBean from './PingTimeBean';
export default class TestProfilesBusinessObject {
    constructor(cdnLoader) {
        this.monitoring = new Map();
        this.pingsTime = new Map();
        this._isMonitoring = false;
        this._cdns = new Map();
        this.testCount = 0;
        this.downloadedSegments = new Array();
        this.cdnLoader = cdnLoader;
    }
    push(segment) {
        if (segment.isManifest)
            return;
        this.downloadedSegments.push(segment);
        if (this.downloadedSegments.length > 10) {
            this.downloadedSegments.shift();
        }
    }
    pop() {
        return this.downloadedSegments.pop();
    }
    monitor(cdns) {
        return __awaiter(this, void 0, void 0, function* () {
            this._cdns = cdns;
            let newMap = new Map();
            for (let value of cdns.values()) {
                newMap.set(value.name, new PingTimeBean());
                this.pingsTime = newMap;
            }
            if (this._isMonitoring)
                return;
            this._isMonitoring = true;
            while (true) {
                let segment = this.downloadedSegments.pop();
                while (!segment) {
                    segment = this.downloadedSegments.pop();
                    yield new Promise(r => setTimeout(r, 1000));
                    // console.log("PINGTIME -> NO REQUEST");
                }
                for (let value of cdns.values()) {
                    if (segment != null) {
                        try {
                            this.testCdn(value, segment);
                        }
                        catch (e) { }
                    }
                    yield new Promise(r => setTimeout(r, 1000));
                }
                yield new Promise(r => setTimeout(r, 10000));
            }
        });
    }
    testCdn(cdn, segment) {
        //  let testBean = this.requests.pop();
        if (segment) {
            let url = this.cdnLoader.updateUrl(segment, cdn.name);
            if (url) {
                let random = Math.floor(Math.random() * 1000000000);
                if (url.includes("?")) {
                    url = url + "&rnpaw=" + random;
                }
                else {
                    url = url + "?rnpaw=" + random;
                }
                const xhr = new XMLHttpRequest();
                let isOk = true;
                let start = Date.now();
                try {
                    xhr.open("HEAD", url, false);
                    xhr.send();
                }
                catch (error) {
                    // isOk= false;
                    cdn.banned = true;
                }
                if (xhr.status >= 200 && xhr.status <= 300) {
                    if (cdn.banned)
                        cdn.banned = false;
                    cdn.failures = 0;
                }
                else {
                    cdn.banned = true;
                }
                let pingTime = Date.now() - start;
                TestProfilesBusinessObject.getInstance().monitoring.set(cdn.name, pingTime);
                let pingTimeBean = TestProfilesBusinessObject.getInstance().pingsTime.get(cdn.name);
                pingTimeBean === null || pingTimeBean === void 0 ? void 0 : pingTimeBean.add(pingTime);
                cdn.lastPingTime = pingTime;
            }
            else {
                //console.log("PINGTIME UNABLE TO GENERATE URL "+cdn.name+" // "+segment.url);
            }
        }
        else {
            // console.log("PINGTIME No available resources to test "+cdn.name);
        }
    }
    static getInstance(cdnLoader) {
        if (cdnLoader != undefined) {
            this._instance = new TestProfilesBusinessObject(cdnLoader);
        }
        return this._instance;
    }
}
